'use client';
import { FC } from 'react';
import clsx from 'clsx';
import ZoomableImage from './ZoomableImage';

interface SolutionItemProps {
  id: any;
  title: string;
  description: string;
  isAds?: boolean;
}

const SolutionItem: FC<SolutionItemProps> = ({ id, title, description, isAds = false }) => {
  return (
    <div className={clsx('col-6 col-md-4 mb-5 text-start px-4', { 'col-lg-3': !isAds })}>
      {isAds ? (
        <img
          src={`/assets/solutions/ads/${id}.png`}
          alt={'solution-' + id}
          style={{ width: '4.5rem', height: '4.5rem' }}
        />
      ) : (
        <ZoomableImage src={`/assets/solutions/${id}.png`} alt={'solution-' + id} />
      )}
      <h5 className="fw-bold mt-4 mb-2 sora">{title}</h5>
      <p className="mb-4" style={{ color: '#686869', lineHeight: 1.5 }}>
        {description}
      </p>
    </div>
  );
};

export { SolutionItem };
